module.exports = __webpack_public_path__ + "img/skhk.2e9e6aea.svg";